export default "__VITE_ASSET__bc767ecd__"